<ion-header>
  <ion-toolbar>
    <ion-title [innerHTML]="'SCENARIOS.ACTION' | translate"></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [formGroup]="form">
  <ion-item>
    <ion-label position="stacked" [innerHTML]="'SCENARIOS.ACTION_TO_DO' | translate"></ion-label>
    <ion-select formControlName="actionId" [interfaceOptions]="{ cssClass: '--l-width' }">
      <ion-select-option
        *ngFor="let action of actions$ | async"
        [value]="action.id"
        [innerHTML]="'ACTIONS.' + action.name | translate"
      ></ion-select-option>
    </ion-select>
  </ion-item>

  <div *ngIf="(this.form.value.actionId) | toAction | async; let action">
    <ng-container *ngFor="let parameter of action.parameters; let index=index">
      <div [ngSwitch]="parameter.type">
        <ion-item class="item" *ngSwitchCase="'boolean'">
          <ion-label
            position="stacked"
            [innerHTML]="('ACTIONS.LABEL.' + action.name + '.' + parameter.name) | uppercase | translate"
          ></ion-label>
          <ion-toggle [formControlName]="parameter.name"></ion-toggle>
        </ion-item>

        <ion-item class="item" *ngSwitchCase="'date'">
          <ion-label
            position="stacked"
            [innerHTML]="('ACTIONS.LABEL.' + action.name + '.' + parameter.name) | uppercase | translate"
          ></ion-label>
          <ion-input id="open-date-trigger-{{index}}" [value]="parameters[parameter.name] | date: 'dd. MMMM YYYY'">
            <ion-popover [size]="'auto'" trigger="open-date-trigger-{{index}}" [cssClass]="['--action-selector']">
              <ng-template>
                <ion-datetime
                  presentation="date"
                  locale="de-DE"
                  [formControlName]="parameter.name"
                  [cancelText]="'BUTTONS.CANCEL' | translate"
                  [doneText]="'BUTTONS.OK' | translate"
                ></ion-datetime>
              </ng-template>
            </ion-popover>
          </ion-input>
        </ion-item>

        <ion-item class="item" *ngSwitchCase="'datetime'">
          <ion-label
            position="stacked"
            [innerHTML]="('ACTIONS.LABEL.' + action.name + '.' + parameter.name) | uppercase | translate"
          ></ion-label>
          <ion-input id="open-date-trigger-{{index}}" [value]="parameters[parameter.name] | date: 'dd. MMMM YYYY HH:mm'">
            <ion-popover [size]="'auto'" trigger="open-date-trigger-{{index}}" [cssClass]="['--action-selector']">
              <ng-template>
                <ion-datetime
                  presentation="date-time"
                  locale="de-DE"
                  [formControlName]="parameter.name"
                  [cancelText]="'BUTTONS.CANCEL' | translate"
                  [doneText]="'BUTTONS.OK' | translate"
                ></ion-datetime>
              </ng-template>
            </ion-popover>
          </ion-input>
        </ion-item>

        <ion-item class="item" lines="none" *ngSwitchCase="'json'">
          <ion-label
            position="stacked"
            [innerHTML]="('ACTIONS.LABEL.' + action.name + '.' + parameter.name) | uppercase | translate"
          ></ion-label>
          <ion-textarea
            class="--json"
            [formControlName]="parameter.name"
            [autoGrow]="true"
            [rows]="5"
            (ionChange)="onJSONChanges($any($event))"
          ></ion-textarea>
          <ion-text *ngIf="jsonError" color="danger" [innerText]="jsonError"></ion-text>
        </ion-item>

        <ion-item class="item" *ngSwitchCase="'number'">
          <ion-label
            position="stacked"
            [innerHTML]="('ACTIONS.LABEL.' + action.name + '.' + parameter.name) | uppercase | translate"
          ></ion-label>
          <ion-input type="number" inputmode="numeric" [formControlName]="parameter.name"></ion-input>
        </ion-item>

        <ion-item class="item" *ngSwitchCase="'select'">
          <ion-label
            position="stacked"
            [innerHTML]="('ACTIONS.LABEL.' + action.name + '.' + parameter.name) | uppercase | translate"
          ></ion-label>
          <ion-select [formControlName]="parameter.name">
            <ion-select-option
              *ngFor="let option of parameter.options"
              [value]="option"
              [innerHTML]="'ACTIONS.LABEL.' + action.name + '.' + option | uppercase | translate"
            ></ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item class="item" *ngSwitchCase="'text'">
          <ion-label
            position="stacked"
            [innerHTML]="('ACTIONS.LABEL.' + action.name + '.' + parameter.name) | uppercase | translate"
          ></ion-label>
          <ion-input type="text" [formControlName]="parameter.name"></ion-input>
        </ion-item>

        <ion-item class="item" *ngSwitchCase="'textarea'">
          <ion-label
            position="stacked"
            [innerHTML]="('ACTIONS.LABEL.' + action.name + '.' + parameter.name) | uppercase | translate"
          ></ion-label>
          <ion-textarea [formControlName]="parameter.name" [autoGrow]="true" [rows]="5"></ion-textarea>
        </ion-item>

        <ion-item class="item" *ngSwitchCase="'time'">
          <ion-label
            position="stacked"
            [innerHTML]="('ACTIONS.LABEL.' + action.name + '.' + parameter.name) | uppercase | translate"
          ></ion-label>
          <ion-input id="open-date-trigger-{{index}}" [value]="parameters[parameter.name] | date: 'HH:mm'">
            <ion-popover [size]="'auto'" trigger="open-date-trigger-{{index}}">
              <ng-template>
                <ion-datetime
                  presentation="time"
                  locale="de-DE"
                  [formControlName]="parameter.name"
                  [cancelText]="'BUTTONS.CANCEL' | translate"
                  [doneText]="'BUTTONS.OK' | translate"
                ></ion-datetime>
              </ng-template>
            </ion-popover>
          </ion-input>
        </ion-item>
      </div>
    </ng-container>
  </div>

  <app-action-params-info></app-action-params-info>
</ion-content>

<ion-footer>
  <ion-button
    class="button --small --primary-outline"
    *ngIf="chanceNodeAction"
    [innerHTML]="'BUTTONS.DELETE' | translate"
    (click)="remove()"
  ></ion-button>
  <ion-button class="button --small --dark-outline" [innerHTML]="'BUTTONS.CANCEL' | translate" (click)="dismiss()"></ion-button>
  <ion-button
    class="button --small --success"
    [disabled]="form.invalid || jsonError || (loading$ | async)"
    [innerHTML]="'BUTTONS.SAVE' | translate"
    (click)="save()"
  ></ion-button>
</ion-footer>
